import { featuredTopics } from "@/mocks/comics";

export default function Featured() {
  return (
    <section id="featured" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-9 flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="text-sm font-bold tracking-wide text-accent-700">FEATURED TOPICS</span>
            <h2 className="mt-2 text-2xl font-black text-foreground-950 md:text-4xl">脑洞神展开专题精选</h2>
            <p className="mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
              由编辑团队精心策划的反转与脑洞专题，把最魔性的内容打包推荐给你。
            </p>
          </div>
          <a
            href="#contact"
            className="inline-flex items-center gap-1 text-sm font-medium text-accent-700 hover:text-accent-800 whitespace-nowrap"
          >
            投稿你的脑洞 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {featuredTopics.map((t, idx) => (
            <article
              key={t.id}
              className="group relative overflow-hidden rounded-2xl border border-background-200 bg-background-50"
            >
              <div className="relative aspect-[3/2] w-full overflow-hidden">
                <img
                  src={t.cover}
                  alt={`${t.title} - 韩国歪歪漫画专题封面`}
                  title={`${t.title} 专题`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span
                  className={`absolute left-3 top-3 rounded-full px-3 py-1 text-xs font-bold ${
                    idx === 0 ? "bg-primary-500 text-background-50" : idx === 1 ? "bg-accent-500 text-foreground-950" : "bg-secondary-500 text-background-50"
                  }`}
                >
                  {t.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-bold leading-snug text-foreground-950 md:text-lg">{t.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{t.desc}</p>
                <a
                  href="#updates"
                  className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700"
                >
                  进入专题 <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}